<template>
  <validation-observer
    v-if="additionalDrivers.length > 0"
    v-slot="observer"
    slim
  >
    <form-section
      id="main-user-of-vehicle"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row :label="title || 'Who will be the main user of the vehicle?'">
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_main-user-of-vehicle`"
          name="Main User of Vehicle"
          rules="required"
        >
          <radio
            v-model="questionData.mainUserOfVehicle"
            :name="`${stepId}-main-user-of-vehicle`"
            :data-test="`${stepId}_main_user_of_vehicle`"
            :items="mainUserOfVehicleOptions"
            :error="failed"
            column
          />
        </validation-provider>
      </form-row>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';

export default {
  name: 'question-main-user-of-vehicle',
  extends: QuestionBase,
  data () {
    return {
      fields: ['mainUserOfVehicle'],
      hasAdditionalDrivers: this.formData.drivers.length > 1,
    };
  },
  computed: {
    additionalDrivers () {
      return this.hasAdditionalDrivers ? this.formData.drivers.filter((d, i) => i > 0) : [];
    },
    mainUserOfVehicleOptions () {
      return this.formData.drivers.map((driver, index) => ({
        value: index + 1,
        text: `${this.constants.TITLES[driver.title]} ${driver.firstName} ${driver.surname}`,
      }));
    },
  },
  created () {
    this.checkMainDriver();
  },
  methods: {
    checkMainDriver () {
      if (this.stepData.mainUserOfVehicle > this.formData.drivers.length) {
        this.questionData.mainUserOfVehicle = 1;
      }
    },
  },
};
</script>
